/* eslint-disable */
import ProductAPI from "./data";

const state = {
  editProduct: null
};

// getters
const getters = {};

// actions
const actions = {
  insert: (context, product) => {
    return ProductAPI.insert(context, product).then(product => {
      context.commit("SET_EDIT_PRODUCT", product);
      return product;
    });
  },
  duplicate: (context, product) => {
    return ProductAPI.duplicate(context, product).then(product => {
      context.commit("SET_EDIT_PRODUCT", product);
      return product;
    });
  },
  update: (context, product) => {
    return ProductAPI.update(context, product).then(product => {
      context.commit("SET_EDIT_PRODUCT", product);
      return product;
    });
  },
  updateContent: (context, product) => {
    return ProductAPI.content.update(context, product).then(content => {
      context.commit("SET_EDIT_PRODUCT_CONTENT", content);
      return content;
    });
  },
  updateLimitedRelease: (context, limited_release) => {
    return ProductAPI.limited_release
      .update(context, limited_release)
      .then(limited_release => {
        return limited_release;
      });
  },
  get: (context, key) => {
    return ProductAPI.get(context, key).then(product => {
      context.commit("SET_EDIT_PRODUCT", product);
      return product;
    });
  },
  getContent: (context, key) => {
    return ProductAPI.content.get(context, key).then(content => {
      context.commit("SET_EDIT_PRODUCT_CONTENT", content);
      return content;
    });
  },
  getLimitedRelease: (context, productID) => {
    return ProductAPI.limited_release
      .get(context, productID)
      .then(limited_release => {
        context.commit("SET_EDIT_LIMITED_RELEASE", limited_release);
        return limited_release;
      });
  },
  export: (context, query) => {
    return ProductAPI.bulk.export(context, query);
  },
  updateAll: (context, formData) => {
    console.log(formData);
    return ProductAPI.bulk.update(context, formData);
  }
};

// mutations
const mutations = {
  SET_EDIT_PRODUCT(state, product) {
    state.editProduct = product;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
